/* global AutoOps */

const initButtons = () => {
	const buttons = document.querySelectorAll(
		'.autoops-button:not(.initialized)'
	);

	buttons.forEach((button) => {
		button.classList.add('initialized');

		button.addEventListener('click', (e) => {
			e.preventDefault();

			if (!window.AutoOps) {
				return;
			}

			AutoOps.show({ portalKey: button.dataset.portalKey });
		});
	});
};

initButtons();

window.addEventListener('propel-filter-locations-loaded', initButtons);
